import { marimoApp } from "./marimo";
import { panelApp } from "./panel";
import { plotlyApp } from "./plotly";
import { streamlitApp } from "./streamlit";

export function exampleFromLibrary(libraryKey: string) {
  switch (libraryKey) {
    case "panel":
      return panelApp;
    case "marimo":
      return marimoApp;
    case "streamlit":
      return streamlitApp;
    case "plotly":
      return plotlyApp;
    default:
      return "";
  }
}
